import { BackendApiClient } from '../api-client';
import { azdanceBookingAuthHeaders } from '@/lib/azdanceBookingSession';

export interface DeleteAztangofestBookingParticipantParams {
  participantId: string;
  language: string;
  accessToken: string;
}

/**
 * DELETE /azdance/booking/participants/:participantId — бронь из JWT (`eventBookingId`), в query только `language`.
 */
export async function deleteAztangofestBookingParticipant(
  params: DeleteAztangofestBookingParticipantParams,
): Promise<void> {
  const { participantId, language, accessToken } = params;
  await BackendApiClient.AzdanceService.azdanceControllerDeleteBookingParticipant(
    { participantId, language },
    { headers: azdanceBookingAuthHeaders(accessToken) } as any,
  );
}
